export const formatCurrency = (amount: number, currency: string = 'GBP'): string => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

export const formatDate = (date: Date | string): string => {
  const d = new Date(date);
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};

export const formatTime = (time: string): string => {
  const [hours, minutes] = time.split(':');
  const date = new Date();
  date.setHours(parseInt(hours, 10));
  date.setMinutes(parseInt(minutes, 10));
  return date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

export const formatDateTime = (date: Date | string, time?: string): string => {
  const formattedDate = formatDate(date);
  if (time) {
    const formattedTime = formatTime(time);
    return `${formattedDate} at ${formattedTime}`;
  }
  return formattedDate;
};

/**
 * Format MPAN number in the standard format: 2 digits, space, 4 digits, space, 4 digits, space, 3 digits
 * Example: "2199999029414" -> "21 9999 9029 414"
 */
export const formatMPAN = (mpan: string | undefined | null): string => {
  if (!mpan) return '';
  
  // Remove any existing spaces or non-digit characters
  const cleanMpan = mpan.replace(/\D/g, '');
  
  // MPAN should be 13 digits
  if (cleanMpan.length !== 13) {
    // Return as-is if not 13 digits (might be MPRN or SPID)
    return mpan;
  }
  
  // Format as: 2 space 4 space 4 space 3
  return `${cleanMpan.slice(0, 2)} ${cleanMpan.slice(2, 6)} ${cleanMpan.slice(6, 10)} ${cleanMpan.slice(10, 13)}`;
};

/**
 * Format status labels - preserves all-caps for acronyms (e.g., "COT / COO") 
 * while applying proper case to other statuses
 * Example: "COT / COO" -> "COT / COO", "live" -> "Live"
 */
export const formatStatusLabel = (status: string | undefined | null): string => {
  if (!status) return '';
  
  // Keep all-caps for acronym statuses (e.g., "COT / COO")
  // Check if status contains only uppercase letters, spaces, and slashes
  if (/^[A-Z\s/]+$/.test(status)) {
    return status;
  }
  
  // Otherwise apply proper case (first letter uppercase, rest lowercase)
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};
